// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PNameOutlinedSvg from "@fishx/icons-svg/es/asn/PNameOutlined";
import FishxIcon from '../components/FishxIcon';

var PNameOutlined = function PNameOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PNameOutlinedSvg
  }));
};

PNameOutlined.displayName = 'PNameOutlined';
export default React.forwardRef(PNameOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PNameOutlined.js
// module id = 3522
// module chunks = 0